export const useMobileAppsDetector = () => {
  function isAndroid () {
    const userAgent = navigator.userAgent;
    const androidPattern = /(\w+)\/([\w.]+)\sAndroid/; // i.e DNApp/1.2.0 Android
    return androidPattern.test(userAgent);
  }

  function isIos () {
    const userAgent = navigator.userAgent;
    const iosPattern = /(\w+)\/([\w.]+)\siOS/; // i.e DNApp/5.6.0 iOS
    return iosPattern.test(userAgent);
  }

  return {
    isAndroid,
    isIos
  };
};
